


















































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
// types
import { Route } from "vue-router";
import { Player, PlayerActionDto, PlayerActionType, PlayerDto } from "@/services/players/types";
import { Solution } from "@/services/solutions/types";
import moment from "moment";
import { bus } from "@/bus";
import { Guid } from "guid-typescript";
// components
import PlayerInfoModal from "@/components/players/modals/PlayerInfoModal.vue";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import SelectSolutionModal from "@/components/solutions/modals/SelectSolutioModal.vue";
import PlayerLogsModal from "@/components/players/modals/PlayerLogsModal.vue";
import SolutionPreviewModal from "@/components/solutions/modals/SolutionPreviewModal.vue";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";
import validate from "@/directives/validate";
// service methods
import { getPlayer, setAction, updatePlayer, getPreviewRenderUrl } from "@/services/players/playerService";
import { getSolution } from "@/services/solutions/solutionService";
import { validateForm } from "@/services/validation/validationService";
import { playerValidators } from "@/components/players/playerValidators";
import { SCREENSHOTENDPOINT } from "@/app.config";

@Component<PlayerForm>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    components: {
        HeaderActionButtons,
        UnsavedFormModal,
        PlayerInfoModal,
        SelectSolutionModal,
        PlayerLogsModal,
        SolutionPreviewModal
    },
    directives: {
        validate
    }
})
export default class PlayerForm extends Vue {
    @Prop() private playerId!: string;
    // local state
    player = { } as Player;
    selectedSolution = {} as Solution;
    changePlayerName = false;
    updatePlayerDataTimer = 0;
    spinnerTimer = 0;
    solutions = [] as Solution[];
    initCompleted = false;
    spinnerActive = false;
    screenshotIsValid = false;
    screenshotUrl = "";

    // used for comparing if form have changes
    priorPlayerState = JSON.parse(JSON.stringify(this.player)) as Player;
    nextRoute = "";
    routeParams = {}
    saveClicked = false;
    continue = false;
    validators = playerValidators;
    // lifecycle hooks
    created() {
        this.fetchData();
    }

    destroyed() {
        clearTimeout(this.updatePlayerDataTimer);
    }

    get screenshotTimeStamp() : string {
        return this.player && this.player.screenshotTimestamp
            ? moment.utc(this.player.screenshotTimestamp).local().format("LLL") : "";
    }

    get showNameInput() : boolean {
        if ((typeof this.validators.name.state !== "undefined" || this.validators.name.state !== null) &&
        this.validators.name.state === false) {
            this.changePlayerName = true;
        }

        return this.changePlayerName;
    }

    get lastActiveDate(): string {
        if (this.player.lastActiveDate) {
            return moment.utc(this.player.lastActiveDate).local().format("LLL");
        }
        return "";
    }
    // methods

    fetchData() {
        getPlayer(this.playerId).then(response => {
            response.name = this.player.name || response.name;
            response.description = this.player.description || response.description;
            this.player = response;
            this.priorPlayerState = JSON.parse(JSON.stringify(this.player)) as Player;
            bus.$emit("documentTitle", this.player.name);
            if (this.player.solutionId) {
                getSolution(this.player.solutionId).then(response => {
                    this.selectedSolution = response;
                });
            }
            this.calculateScreenshotStatus();
            this.calculateSpinnerStatus();
            this.generateScreenshotUrl();
            this.initCompleted = true;
        }).finally(() => {
            this.initPlayerDataTimer();
        });
    }

    // Screenshot
    initPlayerDataTimer() {
        clearTimeout(this.updatePlayerDataTimer);
        this.updatePlayerDataTimer = setTimeout(this.reloadPlayerData, 20000);
    }

    initSpinnerTimer() {
        clearTimeout(this.spinnerTimer);
        this.spinnerTimer = setTimeout(this.calculateScreenshotStatus, 120000);
    }

    reloadPlayerData() {
        getPlayer(this.playerId).then(response => {
            this.player.screenshotTimeZone = response.screenshotTimeZone;
            this.player.hasScreenshot = response.hasScreenshot;
            this.player.screenshotTimestamp = response.screenshotTimestamp;
            this.player.lastScreenshotRequestedDate = response.lastScreenshotRequestedDate;
            this.player.status = response.status;
            this.player.lastActiveDate = response.lastActiveDate;
            this.priorPlayerState.screenshotTimeZone = response.screenshotTimeZone;
            this.priorPlayerState.hasScreenshot = response.hasScreenshot;
            this.priorPlayerState.screenshotTimestamp = response.screenshotTimestamp;
            this.priorPlayerState.lastScreenshotRequestedDate = response.lastScreenshotRequestedDate;
            this.priorPlayerState.status = response.status;
            this.priorPlayerState.lastActiveDate = response.lastActiveDate;
            this.calculateScreenshotStatus();
            this.calculateSpinnerStatus();
        }).finally(() => {
            this.initPlayerDataTimer();
        });
    }

    calculateSpinnerStatus() {
        if (this.player.lastScreenshotRequestedDate !== null) {
            const lastScreenshotRequestedDate = moment.utc(this.player.lastScreenshotRequestedDate);
            const screenshotTimestamp = moment.utc(this.player.screenshotTimestamp!);
            const now = moment.utc(new Date());

            if (screenshotTimestamp > lastScreenshotRequestedDate) {
                this.spinnerActive = false;
            } else {
                const duration = moment.duration(now.diff(lastScreenshotRequestedDate));
                const minutes = duration.asMinutes();
                // show spinner up to 2 minutes after a screenshot is requested
                this.spinnerActive = minutes < 2;
            }
        } else {
            this.spinnerActive = false;
        }
    }

    calculateScreenshotStatus() {
        if (this.player.lastScreenshotRequestedDate !== null && this.player.screenshotTimestamp !== null) {
            const lastScreenshotRequestedDate = moment.utc(this.player.lastScreenshotRequestedDate);
            const screenshotTimestamp = moment.utc(this.player.screenshotTimestamp);
            this.screenshotIsValid = screenshotTimestamp > lastScreenshotRequestedDate;
            if (this.screenshotIsValid) {
                this.generateScreenshotUrl();
            }
        } else {
            this.screenshotIsValid = false;
        }
    }

    generateScreenshotUrl() {
        this.screenshotUrl = `${SCREENSHOTENDPOINT}${this.player.playerId}?random=${Guid.create().toString()}`;
    }
    // End

    reboot() {
        setAction({
            playerId: this.playerId,
            actionType: PlayerActionType.reboot
        } as PlayerActionDto);
    }

    reload() {
        setAction({
            playerId: this.playerId,
            actionType: PlayerActionType.reRender
        } as PlayerActionDto);
    }

    screenshot() {
        setAction({
            playerId: this.playerId,
            actionType: PlayerActionType.screenshot
        } as PlayerActionDto)
            .then(() => {
                this.reloadPlayerData();
                this.initSpinnerTimer();
            });
    }

    enableTeamViewer() {
        setAction({
            playerId: this.playerId,
            actionType: PlayerActionType.teamViewer
        } as PlayerActionDto);
    }

    info(playerId: string) {
        (this.$refs.playerInfoModal as any).open(playerId);
    }

    logs() {
        (this.$refs.playerLogsModal as any).open(this.player.id);
    }

    onBeforeRouteLeave(to: Route, next: any) {
        if (this.saveClicked || this.continue) {
            next();
        } else {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            const noChanges = this.lodash.isEqual(this.priorPlayerState, this.player);
            if (noChanges) {
                next();
            } else {
                next(false);
                (this.$refs.UnsavedFormModal as any).open();
            }
        }
    }

    onContinue(data: boolean) {
        this.continue = data;
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams, query: { folder: this.player.folderId } });
        this.nextRoute = "";
    }

    async save(back: boolean) {
        this.saveClicked = true;
        if (!await validateForm([this.validators])) {
            return;
        }

        const updatedPlayer = {
            solutionId: this.player.solutionId,
            description: this.player.description,
            name: this.player.name,
            id: this.player.id
        } as PlayerDto;

        updatePlayer(updatedPlayer).then(() => {
            if (back) this.$router.push({ path: `/players?folder=${this.player.folderId}` });
            this.priorPlayerState = JSON.parse(JSON.stringify(this.player)) as Player;
            this.saveClicked = false;
        });
    }

    back() {
        window.history.go(-1);
    }

    removeSolution() {
        this.selectedSolution = {} as Solution;
        this.player.solutionId = "";
    }

    openSolutionModal() {
        (this.$refs.selectSolutionModal as any).open([], true);
    }

    previewSolution() {
        (this.$refs.boardPreviewModal as any).open(this.player.solutionId, this.selectedSolution.timeZoneId, this.selectedSolution.width, this.selectedSolution.height, this.selectedSolution.name);
    }

    onSelected(solutions: Solution[]) {
        this.selectedSolution = solutions[0];
        this.player.solutionId = solutions[0].id;
    }

    toggleName() {
    // if input is invalid do nothing
        if (typeof this.validators.name.state !== "undefined" &&
        this.validators.name.state === false) {
            return;
        }

        this.changePlayerName = false;
    }

    navigateToRender() {
        getPreviewRenderUrl(this.player.playerId.toString()).then(response => {
            window.open(response, "_blank");
        });
    }
}
